import { ExtendedRewardDTOType } from '../service/api/aok-rest-api';
import { AokPremiumShopCardViewModel } from './aok-premium-shop-card-view-model';


export class RewardViewModel extends AokPremiumShopCardViewModel{
    articleNumber? : string|undefined;
    description? : string | undefined;
    name? : string|undefined;
    extendedType? : ExtendedRewardDTOType
}